import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import moment, { months } from "moment";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";
import { calculateColumnTotal, getMonthName } from "../General/Utility";

const PrintConcessionsRules = () => {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [listOfLedger, setLedger] = useState([]);

  useEffect(() => {
    document.title = "List Of Concession Rules";

    setLoading(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      pageNo: 1,
      pageSize: 1000,
      SchoolID: 1,
    };

   //console.log(data);
    var api_config = {
      method: "post",
      url: config.base_url + "Concession/GetConcessionRules",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    //console.log(data);

    axios(api_config)
      .then(function (response) {
        setLedger(response.data.ListofRecords);
        setLoading(false);
        setTotalRecords(response.data.totalRecords);
      })
      .catch(function (error) {
        //console.log(error);
      });
  }, []);

  const renderLedger = () => {
    if (listOfLedger.length > 0) {
      let count = 1;

      return listOfLedger.map((item, index) => {
        return (
          <tr key={index}>
            <td>{item.Concession_Rule_ID}</td>
            <td>{item.Concession_Rule_Code}</td>
            <td>{item.Concession_Rule_Name}</td>
            <td>{item.Concession_Percentage}</td>
            <td>{item.Concession_Rule_Detail}</td>
            <td>{item.NoOfStudents}</td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan="6">
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }
  };

  return (
    <>
      <Page orientation="potrait" size="a4">
        <table className="table table-sm table-bordered table-print">
          <thead>
            <tr>
              <td colSpan="6">
                <PrintHeader title={`List Of Concession Rules`} />
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Sr#</th>
              <th>Code</th>
              <th>Rule Name</th>
              <th>Concession Percentage</th>
              <th>Detail</th>
              <th>No of Students</th>
            </tr>
            {loading ? (
              <tr>
                <td className="text-center" colSpan="6">
                  <Spinner animation="border" role="status"></Spinner>
                </td>
              </tr>
            ) : (
              <>{renderLedger()}</>
            )}
          </tbody>
        </table>
      </Page>
    </>
  );
};

export default PrintConcessionsRules;
